import React, { useState } from "react";

const WaitlistForm = () => {
    const [formData, setFormData] = useState({
        childName: '',
        school: '',
        level: '',
        contact: '',
        referer: '',
        branch: '',
    });
    
    const [formState, setFormState] = useState({
        isSubmitting: false,
        isSubmitted: false,
        errors: {}
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        
        // Clear error when user types
        if (formState.errors[name]) {
            setFormState(prev => ({
                ...prev,
                errors: {
                    ...prev.errors,
                    [name]: false
                }
            }));
        }
    };

    const validateForm = () => {
        const errors = {};
        const requiredFields = ['childName', 'school', 'level', 'contact', 'branch'];
        
        requiredFields.forEach(field => {
            if (!formData[field].trim()) {
                errors[field] = true;
            }
        });
        
        setFormState(prev => ({
            ...prev,
            errors
        }));
        
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        
        if (!validateForm()) {
            return;
        }
        
        setFormState(prev => ({
            ...prev,
            isSubmitting: true
        }));
        
        const url = 'https://qoysaws2vjtyywanjyqmt2komu0dqotz.lambda-url.ap-southeast-1.on.aws/';

        try {
            const response = await fetch(url, {
                method: 'POST',
                body: JSON.stringify(formData),
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                    'x-api-key': 'sages-sc-2026-s3cr3t',
                },
            });
            
            await response.json();
            
            setFormData({
                childName: '',
                school: '',
                level: '',
                contact: '',
                referer: '',
                branch: '',
            });
            setFormState(prev => ({
                ...prev,
                isSubmitting: false,
                isSubmitted: true
            }));
        } catch (err) {
            console.error('Error submitting form:', err);
            setFormState(prev => ({
                ...prev,
                isSubmitting: false
            }));
        }
    };

    const buttonText = formState.isSubmitted ? "Submitted!" : (formState.isSubmitting ? "Signing up..." : "Sign up");
    const isDisabled = formState.isSubmitting || formState.isSubmitted;

    return (
        <form id="contact-form" onSubmit={handleSubmit}>
            <div className="row controls">
                <div className="col-md-12">
                    <div className="input-group-meta form-group">
                        <label>Branch</label>
                        <select 
                            name="branch" 
                            value={formData.branch}
                            onChange={handleChange} 
                            disabled={isDisabled} 
                            className={formState.errors.level ? "invalid" : ""}
                        >
                            <option value=""></option>
                            <option value="Admiralty (736 Woodlands Circle)">Admiralty (736 Woodlands Circle)</option>
                            <option value="Choa Chu Kang (207 Choa Chu Kang Central)">Choa Chu Kang (207 Choa Chu Kang Central)</option>
                        </select>
                    </div>
                </div>
            </div>
            <div className="row controls">
                <div className="col-md-4">
                    <div className="input-group-meta form-group">
                        <label>Child's name</label>
                        <input
                            disabled={isDisabled}
                            type="text"
                            placeholder="Enter your child's name"
                            name="childName"
                            value={formData.childName}
                            onChange={handleChange}
                            className={formState.errors.childName ? "invalid" : ""}
                        />
                    </div>
                </div>
                
                <div className="col-md-3">
                    <div className="input-group-meta form-group">
                        <label>Mobile number</label>
                        <input
                            disabled={isDisabled}
                            type="text"
                            placeholder="Enter your mobile number"
                            name="contact"
                            value={formData.contact}
                            onChange={handleChange}
                            className={formState.errors.contact ? "invalid" : ""}
                        />
                    </div>
                </div>
                <div className="col-md-5">
                    <div className="input-group-meta form-group">
                        <label>Referred by (Optional)</label>
                        <input
                            disabled={isDisabled}
                            type="text"
                            placeholder="Enter name of parent/child who recommended"
                            name="referer"
                            value={formData.referer}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
            <div className="row controls">
                <div className="col-md-6">
                    <div className="input-group-meta form-group">
                        <label>School</label>
                        <input
                            disabled={isDisabled}
                            type="text"
                            placeholder="Enter your child's school"
                            name="school"
                            value={formData.school}
                            onChange={handleChange}
                            className={formState.errors.school ? "invalid" : ""}
                        />
                    </div>
                </div>
                {/* End .col */}
                <div className="col-md-3">
                    <div className="input-group-meta form-group">
                        <label>Level in 2026</label>
                        <select 
                            name="level" 
                            value={formData.level}
                            onChange={handleChange} 
                            disabled={isDisabled} 
                            className={formState.errors.level ? "invalid" : ""}
                        >
                            <option value=""></option>
                            <option value="K2">K2</option>
                            <option value="Primary 1">Primary 1</option>
                            <option value="Primary 2">Primary 2</option>
                            <option value="Primary 3">Primary 3</option>
                            <option value="Primary 4">Primary 4</option>
                            <option value="Primary 5">Primary 5</option>
                            <option value="Primary 6">Primary 6</option>
                        </select>
                    </div>
                </div>
                <div className="col-md-3">
                    <button type="submit" disabled={isDisabled}>{buttonText}</button>
                </div>
            </div>
        </form>
    );
};

export default WaitlistForm;